import React, { useState, useEffect } from "react";
import { Grid, makeStyles, withStyles, Card } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ObligatoryIcon from "../../icons/ObligatoryIcon";
import BasketIcon from '../../icons/BasketIcon';
import SolutionsIcon from '../SolutionsIcon';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import axios from 'axios';
import config from '../../other/config';
const {serverAPI} = config;

export default function SolutionLineCard(props) {
	const classes = useStyles();
	const lang = localStorage.getItem('language') || 'Ru';
	let [allCheckBox, setAllCheckBox] = useState(false);
	let [checkAll, setCheckAll] = useState(false);
	let { cardArr } = props;

	// function ActionSolution(ID) {
	// 	if (localStorage.getItem('cartSolutions') && localStorage.getItem('cartSolutions').includes(ID)) {
	// 		addSolution(ID)
	// 	} else {
	// 		removeSolution(ID)
	// 	}
	// }

	// const addSolution = async (ID) => {
	// 	const _card = await axios.get(`${serverAPI}/solutionsidv/${ID}/${lang}/0`)

	// 	if (_card && _card.data && _card.data.length > 0) {
	// 		let apps = _card.data;
	// 		let basketApp = JSON.parse(localStorage.getItem('cartApp')) || [];

	// 		if (allCheckBox === true) {
	// 			basketApp = basketApp.filter(item => !apps.includes(item))
	// 			localStorage.setItem('cartApp', JSON.stringify(basketApp))
	// 			localStorage.setItem('cartSolutions', JSON.stringify(ID))
	// 			setCheckAll(!checkAll)
	// 		} else {
	// 			let unique = uniqueArr(basketApp.concat(apps));
	// 			localStorage.setItem('cartApp', JSON.stringify(unique))
	// 			localStorage.setItem('cartSolutions', JSON.stringify(ID))
	// 			setCheckAll(!checkAll)
	// 			let bA1 = basketApp.filter(item => apps.includes(item))
	// 			// console.log(apps.length - bA1.length)
	// 			// _snackbar([true, apps.length - bA1.length])
	// 		}
	// 	}
	// }

	// const removeApp = (app) => {
	//   const appBasketNew = JSON.parse(localStorage.getItem('cartApp') || [])
	//   if (appBasketNew.some((element) => element === app.ID) === true) {
	//     localStorage.setItem('cartApp', JSON.stringify(appBasketNew.filter(el_ => el_ !== app.ID)))
	//   }
	//   // _resetState(!resetState)
	// }

	const removeSolution = async (ID) => {
		// 	const _card = await axios.get(`${serverAPI}/solutionsidv/${ID}/${lang}/0`)
		// 	const appBasketNew = JSON.parse(localStorage.getItem('cartApp') || [])

		// 	if (_card && _card.data && _card.data.length > 0) {
		// 		let apps = _card.data;
		// 		let basketApp = JSON.parse(localStorage.getItem('cartApp')) || [];

		// 		if (allCheckBox === true) {
		// 			basketApp = basketApp.filter(item => !apps.includes(item))
		// 			localStorage.setItem('cartApp', JSON.stringify(basketApp))
		// 			localStorage.setItem('cartSolutions', JSON.stringify(ID))
		// 			setCheckAll(!checkAll)
		// 		} else {
		// 			let unique = uniqueArr(basketApp.concat(apps));
		// 			localStorage.setItem('cartApp', JSON.stringify(unique))
		// 			localStorage.setItem('cartSolutions', JSON.stringify(ID))
		// 			setCheckAll(!checkAll)
		// 		}
		// 	}
	}

	function uniqueArr(arr) {
		let result = [];

		for (let str of arr) {
			if (!result.includes(str)) {
				result.push(str);
			}
		}

		return result;
	}

	function renderAction(card) {
		let apps = card.AppsIDsNeeded ? card.AppsIDsNeeded.trim().split(/\s*,\s*/).map(Number) : ''
		let basketApp = JSON.parse(localStorage.getItem('cartApp')) || [];
		let bA1 = basketApp.filter(item => apps.includes(item))

		if (bA1.length !== apps.length) {
			return (
				<CustomTooltip placement="top" title={translate.Words[`AddTobasket${lang}`]}>
					<IconButton className={classes.icon} onClick={() => props.setBasketSolution(card)} style={{ backgroundColor: '' }}>
						<BasketIcon fill={'#BCBBD0'} />
					</IconButton>
				</CustomTooltip>
			)
		}
	}

	useEffect(() => {
		let basketProd = JSON.parse(localStorage.getItem('cartApp')) || []
		let isAll = cardArr.every(el => basketProd.includes(el.ID))
		setAllCheckBox(isAll)
	}, [cardArr, checkAll]);

	return (
		cardArr.map((el, id) =>
			<Grid item style={{ width: '100%' }}>
				<Card className={classes.root}>
					<CardContent className={classes.CardContentRoot}>
						<Grid container direction="row" justify="flex-start">
							<Grid item container direction="row" style={{ width: 'calc(100% - 400px)', minWidth: 263 }}>
								{/* <Avatar
									className={classes.avatar}
									style={{ backgroundColor: '#8094FF' }}
								// src={}
								>
									<SolutionsIcon fill="#FFFFFF" />
								</Avatar> */}

								<Avatar aria-label="recipe" className={classes.avatar} src={`${serverAPI}/9cade9b5a064f0d99ee9501f09588081/pict/Group%20597.svg`} />

								<a href={`/solutions/${el.url}/overview`} style={{ textDecoration: 'none', maxWidth: 'calc(100% - 62px)' }} rel="noopener noreferrer" target="_blank" rel="noopener noreferrer" >
									<Grid container className={classes.InfoCntr}>
										<Typography className={classes.Body2medium}>
											{el.Title}
										</Typography>

										<Typography className={classes.Caption1} style={{ marginTop: 8 }}>
											{el.BriefDescription}
										</Typography>
									</Grid>
								</a>
							</Grid>

							<Grid item container direction="column" justify="flex-start" className={classes.container} style={{ margin: 0, height: 86, width: 264 }}>
								<Grid item style={{ marginBottom: 6 }}>
									<Typography className={classes.Body2medium}>{translate.Words[`Applications_${lang}`]}</Typography>
								</Grid>

								<Grid item container direction="row" className={classes.priceContainer}>
									<Grid item style={{ width: 24 }}>
										<ObligatoryIcon fill={'#EB505E'} />
									</Grid>

									<Grid item style={{ width: 190 }}>
										<Typography className={classes.Caption1}>{translate.Words[`LicensingRequired${lang}`]}</Typography>
									</Grid>

									<Grid item style={{ marginLeft: 25 }}>
										<Typography className={classes.Caption1} style={{ color: '#24262A' }}>{el.AppsIDsNeededCount}</Typography>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</CardContent>

					<CardActions disableSpacing className={classes.CardActionsRoot}>
						{renderAction(cardArr[id])}
					</CardActions>
				</Card >
			</Grid>
		)
	)
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		// height: 418,
		borderRadius: 16,
		boxShadow: 'none',
		padding: '40px 24px 16px'
	},

	CardContentRoot: {
		padding: 0,
		// height: 228
	},

	InfoCntr: {
		height: 76,
		width: '100%',
		maxWidth: 535,
		overflow: 'hidden',
		paddingLeft: theme.spacing(3.25)
	},

	CardActionsRoot: {
		padding: 0,
		paddingTop: 14
	},

	icon: {
		backgroundColor: '#F6F6FB',
		marginLeft: 'auto',
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
	},

	avatar: {
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15,
		backgroundColor: '#EBEEFF',
	},

	Body2medium: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '14px',
		lineHeight: '18px',
		color: '#000000'
	},

	Caption1: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#8987A2'
	},

	priceContainer: {
		padding: '4px 0'
	}
}));